module.exports = __webpack_public_path__ + "img/bg-header-stt-overdue-del.4f0bc5d0.svg";